import Hero from "./HeroSection";
import { Helmet } from "react-helmet-async";
import Globaltradepoints from "./TradePointsSection";
import Howitworks from "./HowItWorkSection";
import Livefxrates from "./FxRateSection";
import Paymenttracking from "./TrackPaymentSection";
import Boe from "./Boe&ShippingSection";
import Partners from "./PartnerSection";
import Endcta from "./FooterCTA";
import Testimonials from "../TestimonialCarouselSection";
import Accordion2 from "./FooterFAQ";
import { trackPageView} from '../../../utlis/useAnalytics';
import { useEffect } from "react";
import {PageName} from '../../../configs/config'

export default function HomePage() {
  useEffect(() => {
    trackPageView(PageName.GlobalTrade);
  }, []);
  return (
  <><Helmet>
      <title>Open a Global Trade Account – International Payments with EximPe</title>
      <meta name="description" content="Unlock global markets with EximPe’s Global Trade Account. Enjoy secure, multi-currency transactions and simplified international business banking solutions.Unlock global markets with EximPe’s Global Trade Account. Enjoy secure, multi-currency transactions and simplified international business banking solutions." />
    </Helmet>
    <div className="overflow-x-hidden overflow-y-hidden w-full md:mt-[20px]">

        {/* Hero Section */}
        <Hero />

        {/* Global Trade Points Section */}
        <Globaltradepoints />

        {/* How It Works Section */}
        <Howitworks />

        {/* Live FX Rates Section */}
        <Livefxrates />

        {/* Payment Tracking Section */}
        <Paymenttracking />

        {/* BOE and Shipping Section */}
        <Boe />

        {/* Testimonials Section */}
        <div className="mt-[140px]">

          <Testimonials />
        </div>


        {/* Partners Section */}
        <Partners />

        {/* FAQ Section */}
        <Accordion2 />

        {/* Final CTA Section */}
        <Endcta />
      </div></>
  );
}
